import {
  queryCustList,
  queryCustWriteOffRecordByPage,
  custOrderByPage
} from '@/api/sys.cust'

export default {
  namespaced: true,
  actions: {
    /**
         * 分页查询
         */
    queryCustList ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryCustList(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryCustWriteOffRecordByPage ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryCustWriteOffRecordByPage(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    custOrderByPage ({
      dispatch
    }, {
      vm,
      data
    }) {
      return custOrderByPage(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    }
  }
}
